<template>
  <div class="container">
    <img src="https://cdn.alighting.com/wxopen/cover/2024expo_intro_1.png" />
    <div class="video">
        <video id="myVideo" :custom-cache="false" src="http://1258245685.vod2.myqcloud.com/f01ca598vodtranscq1258245685/c9f6f5c95285890802616500388/v.f100040.mp4" controls poster=""></video>
    </div>
    <!-- tab栏 -->
    <div class="tab-box">
      <div class="tb_main">
        <div :class="{'act':type==1}" @click="type=1">广州国际照明展览会<span></span></div>
        <div :class="{'act':type==2}" @click="type=2">广州国际建筑电气技术展览会<span></span></div>
      </div>
    </div>
    <img src="https://cdn.alighting.com/wxopen/cover/2023expo_intro_gy.png" v-if="type==1" />
    <img src="https://cdn.alighting.com/wxopen/cover/2023expo_intro_dq.png" v-else />
    <img src="https://cdn.alighting.com/wxopen/cover/2023expo_intro.png" />
  </div>
</template>
<script>
export default {
  name: "exhibitionIntroduce",
  components: {},
  data() {
    return {
      type: 1, //1光亚展 2电气
    };
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
  img{
      width: 100%;
      display: block;
  }

  .video {
      width: 335px;
      height: 190px;
      position: absolute;
      z-index: 5;
      left: 20px;
      top: 250px;
  }

  .video video {
      width: 100%;
      height: 100%;
  }

  .tab-box{
      margin-top: 75px;
  }

  .tb_main{
      position: relative;
      height: 37px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      padding: 0 2px;
  }

  .tb_main::before{
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 10px;
      height: 2px;
      background-color: #B72240;
  }

  .tb_main::after{
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 25px;
      height: 2px;
      background-color: #0A5ECC;
  }

  .tb_main div{
      position: relative;
      z-index: 3;
      left: 0;
      top: 9px;
      width: 178px;
      height: 47px;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      font-size: 12px;
      line-height: 22px;
  }

  .tb_main div.act{
      font-weight: bold;
      line-height: 37px;
      font-size: 13px;
      z-index: 5;
      top: 0px;
  }

  .tb_main div.act span{
      position: absolute;
      z-index: 5;
      left: 50%;
      top: 32px;
      transform: translate(-50%, 0);
      width: 0;
      height: 0;
      border-left: 10px solid transparent;  
      border-right: 10px solid transparent;  
      border-bottom: 10px solid #F1F1F1; 
  }

  .tb_main div::before{
      content: "";
      position: absolute;
      z-index: -1;
      left: -9px;
      top: 2px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 45px solid #B72240; 
  }

  .tb_main div::after{
      content: "";
      position: absolute;
      z-index: -1;
      right: -9px;
      top: 2px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 45px solid #B72240; 
  }

  .tb_main div:first-child{
      background-color: #B72240;
  }

  .tb_main div:nth-child(2){
      background-color: #0A5ECC;
  }

  .tb_main div:nth-child(2)::before{
      border-bottom: 45px solid #0A5ECC; 
  }

  .tb_main div:nth-child(2)::after{
      border-bottom: 45px solid #0A5ECC; 
  }
</style>

